import React from 'react';
import { useTranslation } from 'react-i18next';

const CommentCountComp = ({ count }) => {
    const {t} = useTranslation()
    let lable = t('Comments');
    if (count == 1) {
        lable = t('Comment');
    }
    return (
        <div className="cmt-comments-label">
            <span className="cmt-count">{count}</span>
            <div className="cmt-lable" role="heading" aria-level={2}>{lable}</div>
        </div>

    )
}

export default CommentCountComp;
